import cx from "classnames";

import Column from "../../../../Column";

import styles from "./styles.module.scss";
/**
 *
 * @param {object} props
 * @param {import("react").ReactNode} props.children
 * @returns
 */
const Pricing = ({ children, className }) => {
  return (
    <ul className={cx(styles.pricing, className)}>
      <Column className={styles.col}>{children}</Column>
    </ul>
  );
};

export default Pricing;
